var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.bb627220d61a346426376a1c2cafc8ad.svg#bx';
                    var viewUrl = 'sprites.bb627220d61a346426376a1c2cafc8ad.svg#view-bx';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 286 109',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };